import React from 'react';

interface LocationHeaderProps {
  title: string;
}

const LocationHeader: React.FC<LocationHeaderProps> = ({ title }) => {
  return (
    <div className="mb-8">
      <h2 className="text-2xl font-semibold text-gray-900 tracking-tight">
        {title}
      </h2>
      <div className="h-1 w-20 bg-airbnb-red mt-2 rounded-full"></div>
    </div>
  );
};

export default LocationHeader;